import { BellRing } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { MaildeskTriagePage } from './pages/MaildeskTriagePage'

/**
 * MailDesk Triage — Inbox Actions (Sprint 27, 2026-05-08).
 *
 * Replaces the eyeball-1000-unread-emails workflow with a classified,
 * deduplicated, ranked action-item list pulled from MailDesk's Orders
 * + Purchasing + Support + Regulatory inboxes.
 *
 * Phase 1 = visibility only. CARLA classifies; humans decide and
 * respond. No auto-action, no auto-reply.
 *
 * Spec: /opt/ai-coworker/MailDesk_Triage_Interface_Middleware_Spec_v10.md
 * Sprint doc: /opt/ai-coworker/docs/active/sprint-27-maildesk-triage-phase-1.md
 */
export default defineModule({
  id: 'maildesk-triage',
  name: 'Inbox Actions',
  shortName: 'Inbox Actions',
  icon: BellRing,
  // 'customer_service' was already in the NavSection enum + Shell
  // SECTION_ORDER but had no resident modules. Sprint 27 D-11.
  navSection: 'customer_service',
  navOrder: 1,
  urlNamespace: '/maildesk-triage',
  routes: [
    { path: '/', element: MaildeskTriagePage, label: 'Inbox Actions' },
  ],
  // outside_sales_rep excluded (2026-07-21): password-login field reps get
  // a narrowed sidebar (Orders + Quotes only) — no Inbox Actions.
  permissions: [
    'admin',
    'sales',
    'operations', 'operations_logistics', 'purchasing',
    'finance',
    'regulatory',
    'inside_sales_rep',
  ],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g n',

  commandPaletteEntries: [
    {
      label: 'Go to Inbox Actions',
      keywords: [
        'inbox',
        'maildesk',
        'triage',
        'email',
        'actions',
        'urgent',
        'follow up',
      ],
      path: '/',
      group: 'modules',
      shortcut: 'g n',
    },
  ],
})
